import {
  cachePayloadForKey,
  PL_PREQUAL_RESULT_KEY,
} from 'actions/datacache.actions';
import { wrapService } from 'actions/service_wrapper.actions';
import {
  fetchPersonalLoanPreApprovals,
  fetchPrequalFormData,
} from 'externals/_services/product.service';
import { getPartnerForUnifiedExperience } from './hooks/personalLoanMarketplacePrequal.hook';
import { parsePlPrequalOffer } from '../PersonalLoanPrequalResultModule/hooks/PersonalLoanPrequalResultModule.hook';

const a_fetchPersonalLoanPreApprovals = wrapService(
  fetchPersonalLoanPreApprovals,
  {
    name: 'fetchPersonalLoanPreApprovals',
  },
);

const a_fetchPrequalFormData = wrapService(fetchPrequalFormData, {
  name: 'fetchPrequalFormData',
});

export const retrievePrequalFormData = () => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    const partner = getPartnerForUnifiedExperience();
    dispatch(a_fetchPrequalFormData('PERSONAL_LOAN', partner))
      .then(result => {
        //clean up the form
        delete result['createDate'];
        delete result['updateDate'];

        const prequalData = {
          formInput: result,
        };
        dispatch(cachePayloadForKey(PL_PREQUAL_RESULT_KEY, prequalData));
        resolve(result);
      })
      .catch(err => {
        dispatch(
          cachePayloadForKey(PL_PREQUAL_RESULT_KEY, { isEmptyForm: true }),
        );
        reject(err);
      });
  });
};

export const getPersonalLoanPreApprovals =
  (userInfo, prequalResultData) => (dispatch, getState) => {
    const userId = userInfo ? userInfo.userId : '';
    const formInput = prequalResultData ? prequalResultData.formInput : null;

    return new Promise((resolve, reject) => {
      const extraParams = {
        userId,
        sort: 'UNIFIED_LOAN_AMOUNT_APR',
      };

      if (!prequalResultData.fromPrequalForm) {
        extraParams.cachedOffers = true;
      }

      const finalParams = extraParams.cachedOffers
        ? extraParams
        : Object.assign(extraParams, formInput);

      dispatch(a_fetchPersonalLoanPreApprovals(finalParams))
        .then(result => {
          if (result.offers && result.offers.length > 0) {
            result.offers = result.offers.map((offer, index) =>
              parsePlPrequalOffer(offer, index + 1, result),
            );

            prequalResultData.result = result;
            dispatch(
              cachePayloadForKey(PL_PREQUAL_RESULT_KEY, prequalResultData),
            );
          }
          resolve(result);
        })
        .catch(err => {
          reject(err);
        });
    });
  };
